import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service/admin.service';

const NS = 'CreateSchedule';

const template = require('./createSchedule.html');

export default function CreateSchedule() {
  "ngInject";

  return {
    scope: true,
    bindToController: {
      schedule: '=',
      isDisabled: '=',
      displayErrors: '=',
      checkCount: '='
    },
    controller,
    controllerAs: 'vm',
    restrict: 'E',
    template
  };

  function controller($scope, $filter, scheduleService, appConstants, unregister) {
    "ngInject";

    const vm = this;

    //-- define public properties
    vm.displayErrors = true;
    //-- define public methods
    vm.edit = edit;
    vm.addService = addService;
    vm.toggleOpen = toggleOpen;
    vm.deleteService = deleteService;
    vm.checkDateDay = checkDateDay;
    //-- listen
    var listeners = [];
    listeners.push($scope.$watch('scheduleForm.$valid', validUpdate));
    listeners.push($scope.$watch('vm.checkCount', showErrors));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    function deleteService(schedule, index) {
      schedule.services.splice(index, 1);
    }

    function addService(schedule) {
      var lastService;
      if (schedule.services.length) {
        lastService = schedule.services[schedule.services.length - 1];
      }
      const timeZoneId = AdminService.getVenueTimezoneId();
      var startTime = DateUtilsService.getClearDate(null, timeZoneId);
      startTime.setHours(8);
      var bookingDuration = 90;
      if (lastService) {
        // if there is a service before this one start right after it
        startTime = (lastService.endTime) ? lastService.endTime : startTime;
        bookingDuration = (lastService.bookingDuration) ? lastService.bookingDuration : bookingDuration;
      }
      var endTime = new Date(startTime.getTime());
      endTime.setHours(endTime.getHours() + 3);
      var lastBookingTime = new Date(endTime.getTime());
      lastBookingTime.setMinutes(lastBookingTime.getMinutes() - 15);

      schedule.services.push({
        name: '',
        startTime: startTime,
        endTime: endTime,
        lastBookingTime: lastBookingTime,
        bookingDuration: bookingDuration,
        paymentDetails: {
          paymentType: appConstants.Payment.PaymentTypes.NoPayment,
          peopleRequired: 1
        }
      });
    }

    function edit(schedule) {
      var orgValue = schedule.edit;
      for (var i = vm.schedule.days.length - 1; i >= 0; i--) {
        vm.schedule.days[i].edit = false;
      }
      schedule.edit = !orgValue;
    }

    function toggleOpen(schedule) {
      if (!schedule.isOpen) {
        schedule.edit = false;
      }
    }

    function validUpdate() {
      $scope.vm.isDisabled = ($scope.scheduleForm) ? !$scope.scheduleForm.$valid : false;
    }

    function checkDateDay(date, service, dateParam) {
      const timeZoneId = AdminService.getVenueTimezoneId();
      var todaysDate = DateUtilsService.getVenueTime(timeZoneId);
      service[dateParam] = DateUtilsService.checkDateDay(date, todaysDate);
    }

    function showErrors() {
      if (vm.displayErrors) {
        for (var i = 0; i < vm.schedule.days.length; i++) {
          var schedule = vm.schedule.days[i];
          if (!$scope.scheduleForm['schedule-' + schedule.dayName].$valid) {
            schedule.edit = true;
          }
        }
      }
    }

  }
}

